$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - 130;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  $(window).on('scroll', function () {
    console.log('run')
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll');
      }
    });
  })

  function setupCollectionCard($collectionCard) {
    const $watchImage = $collectionCard.find('.js-watch-img');
    const $watchLink = $collectionCard.find('.js-watch-link');

    function onThumbClick($clickedThumb) {
      const newSrc = $clickedThumb.attr('src');
      const $clickedItem = $clickedThumb.closest('.js-var-item');
      const clickedUrl = $clickedItem.data('url');

      const currentSrc = $watchImage.attr('src');
      const currentUrl = $watchLink.attr('href');

      const replacementThumb = $(`
      <div class="item-collection__var__item js-var-item" data-url="${currentUrl}">
        <img src="${currentSrc}" alt="" class="js-watch-thumb">
      </div>
    `);

      $watchImage.fadeOut(200, function () {
        // 選択したサムネと現在のメイン画像を入れ替え
        $clickedItem.replaceWith(replacementThumb);

        // メイン画像とリンクの更新
        $watchImage.attr('src', newSrc).fadeIn(200);
        $watchLink.attr('href', clickedUrl);

        // 新しく追加されたサムネにイベントを再バインド
        setupThumbEvents($collectionCard);
      });
    }

    function setupThumbEvents($card) {
      $card.find('.js-watch-thumb').off('click').on('click', function () {
        onThumbClick($(this));
      });
    }

    setupThumbEvents($collectionCard);
  }

  // 全体に適用
  $('.js-collection-card').each(function () {
    setupCollectionCard($(this));
  });
});